// Author YuJiaBei
// Date 2024-06-12 16:40:31

import * as model from "@/model/sithMes/prd/SithMesPrdPpHeaderModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpHeader(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'virtualFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'dispatchFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'executeFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'virtualVo'
    })
    .buildStore()
